import api from './api';

/**
 * Serviço de Agendamentos de WhatsApp
 * Gerencia as chamadas à API de agendamento de notificações WhatsApp
 */
const agendamentoWhatsAppService = {
  
  /**
   * Listar agendamentos com filtros e paginação
   * @param {Object} params - Parâmetros de filtro
   * @param {number} params.page - Número da página
   * @param {number} params.limit - Limite por página
   * @param {string} params.status - Status do agendamento
   * @param {string} params.tipo_relatorio - Tipo de relatório
   * @param {string} params.search - Busca por nome/descrição
   * @param {boolean} params.ativo - Filtrar ativos/inativos
   */
  async listar(params = {}) {
    try {
      const response = await api.get('/agendamentos-whatsapp', { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao listar agendamentos:', error);
      throw error;
    }
  },

  /**
   * Buscar agendamento por ID
   * @param {number} id - ID do agendamento
   */
  async buscarPorId(id) {
    try {
      const response = await api.get(`/agendamentos-whatsapp/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar agendamento:', error);
      throw error;
    }
  },

  /**
   * Criar novo agendamento
   * @param {Object} dados - Dados do agendamento
   */
  async criar(dados) {
    try {
      const response = await api.post('/agendamentos-whatsapp', dados);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar agendamento:', error);
      throw error;
    }
  },

  /**
   * Atualizar agendamento
   * @param {number} id - ID do agendamento
   * @param {Object} dados - Dados a atualizar
   */
  async atualizar(id, dados) {
    try {
      const response = await api.put(`/agendamentos-whatsapp/${id}`, dados);
      return response.data;
    } catch (error) {
      console.error('Erro ao atualizar agendamento:', error);
      throw error;
    }
  },

  /**
   * Deletar agendamento (soft delete)
   * @param {number} id - ID do agendamento
   */
  async deletar(id) {
    try {
      const response = await api.delete(`/agendamentos-whatsapp/${id}`);
      return response.data;
    } catch (error) {
      console.error('Erro ao deletar agendamento:', error);
      throw error;
    }
  },

  /**
   * Pausar ou retomar agendamento
   * @param {number} id - ID do agendamento
   */
  async toggleStatus(id) {
    try {
      const response = await api.put(`/agendamentos-whatsapp/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      console.error('Erro ao alterar status:', error);
      throw error;
    }
  },

  /**
   * Executar agendamento manualmente (enviar agora)
   * @param {number} id - ID do agendamento
   */
  async executarManualmente(id) {
    try {
      const response = await api.post(`/agendamentos-whatsapp/${id}/executar`);
      return response.data;
    } catch (error) {
      console.error('Erro ao executar agendamento:', error);
      throw error;
    }
  },

  /**
   * Pré-visualizar relatório
   * @param {string} tipo_relatorio - Tipo do relatório
   * @param {Object} configuracao_relatorio - Configurações do relatório
   */
  async previewRelatorio(tipo_relatorio, configuracao_relatorio = {}) {
    try {
      const response = await api.post('/agendamentos-whatsapp/preview', {
        tipo_relatorio,
        configuracao_relatorio
      });
      return response.data;
    } catch (error) {
      console.error('Erro ao gerar preview:', error);
      throw error;
    }
  },

  /**
   * Buscar histórico de disparos de um agendamento
   * @param {number} id - ID do agendamento
   * @param {Object} params - Parâmetros de paginação
   */
  async buscarHistorico(id, params = {}) {
    try {
      const response = await api.get(`/agendamentos-whatsapp/${id}/historico`, { params });
      return response.data;
    } catch (error) {
      console.error('Erro ao buscar histórico:', error);
      throw error;
    }
  },

  /**
   * Obter tipos de relatório disponíveis
   */
  async getTiposRelatorio() {
    try {
      const response = await api.get('/agendamentos-whatsapp/tipos-relatorio');
      return response.data;
    } catch (error) {
      console.error('Erro ao obter tipos de relatório:', error);
      throw error;
    }
  },

  /**
   * Obter recorrências disponíveis
   */
  async getRecorrencias() {
    try {
      const response = await api.get('/agendamentos-whatsapp/recorrencias');
      return response.data;
    } catch (error) {
      console.error('Erro ao obter recorrências:', error);
      throw error;
    }
  },

  /**
   * Verificar status da conexão WhatsApp
   */
  async verificarWhatsApp() {
    try {
      const response = await api.get('/agendamentos-whatsapp/whatsapp/status');
      return response.data;
    } catch (error) {
      console.error('Erro ao verificar WhatsApp:', error);
      throw error;
    }
  }
};

export default agendamentoWhatsAppService;
